#import "../fragments/entity-summary-fragment.graphql"

mutation GenerateEntitySummary($input: EntitySummaryGenerateInput!) {
    entitySummaryGenerate(input: $input) {
        entitySummary {
            ...EntitySummaryFragment
        }
    }
}
